import React from 'react';
import {
  Box,
  Typography,
  Stack,
} from '@mui/material';
import {
  LinkExternal,
} from '@marageti/z4-lib';
import { ReactComponent as ZicassoSVG } from '../../../assets/svg/zicasso-logo-redesign.svg';
import { ViewProps } from '../logged-in-user/types';
import './confirmation.scss';
import config from '../../../config';

const View = ({ email }:ViewProps): React.ReactElement => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mx: '20px',
    }}
  >
    <Stack
      spacing={3}
      sx={{
        width: { desktop: '420px' },
        maxWidth: '420px',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stack flexDirection="column" spacing="16px" alignItems="center">
        <ZicassoSVG aria-label="Zicasso" />
        <Typography
          component="h1"
          variant="h2"
          color="text.primary"
          sx={{
            textAlign: 'center',
            fontWeight: '700',
          }}
        >
          Thank you! Please check
          <br />
          your email.
        </Typography>
        <Typography
          color="text.secondary"
          sx={{
            textAlign: 'center',
          }}
        >
          We&apos;ve sent a confirmation email to
          <br />
          <span style={{ fontWeight: 'bold' }}>{email}</span>
          .
          {' '}
          Please confirm your Zicasso account via this email to see your trip request details.
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" style={{ marginTop: '32px', textAlign: 'center' }}>
          Need help?
          {' '}
          <LinkExternal
            ariaLabel="Tech Support"
            color="text.secondary"
            href={`${config.Z3_URL}contact`}
            variant="caption"
            underline="always"
          >
            Contact Support Center
          </LinkExternal>
        </Typography>
      </Stack>
    </Stack>
  </Box>
);
export default View;
